import OrderCloudHistoryModal from "./order-cloud-history-modal.component";

export default OrderCloudHistoryModal;
